module.exports = __webpack_public_path__ + "img/qrcode-wechat.57464905.png";